module.exports = __webpack_public_path__ + "static/shape-right-dbc79b79a05b2f223741e50a97a627aa.png";